import React from 'react';
import { Grid, Header, Segment, Tab } from 'semantic-ui-react';
import Responsive from 'semantic-ui-react/dist/commonjs/addons/Responsive';
import { ToastContainer } from 'react-toastify';
import DocumentTemplateConfiguration from './DocumentTemplateConfiguration';
import TemplateCatalogOverview from './TemplateCatalogOverview';


export default class TemplateConfig extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            step: 0,
            sharedSelection: {
                scope: 'ou',
                faculty: '',
                studyProgram: '',
                templateConfig: '',
                template: '',
            },
        };
        this.changeStep = this.changeStep.bind(this);
        this.handleSelectionChange = this.handleSelectionChange.bind(this);
    }

    changeStep(step) {
        this.setState({ step });
    }

    handleSelectionChange(partialSelection) {
        this.setState(prevState => ({
            sharedSelection: {
                ...prevState.sharedSelection,
                ...partialSelection,
            },
        }));
    }

    componentDidMount() {
        let element = document.querySelectorAll('#myTab:nth-child(1)');
        if (element[0] && element[0].childNodes[1]) {
            element[0].childNodes[1].classList.remove('segment');
        }
    }


    render() {
        const { sharedSelection } = this.state;
        const activeRole = localStorage.getItem('activeRole') || '';
        const isAdmin = activeRole.substr(0, 13) === 'Administrator';
        const panes = [
            {
                menuItem: 'Pregled',
                render: () => (<Tab.Pane attached={false} responsive={Responsive} >
                    <DocumentTemplateConfiguration
                        changeStep={this.changeStep}
                        sharedSelection={sharedSelection}
                        onSelectionChange={this.handleSelectionChange}
                    />
                </Tab.Pane>),
            },
            {
                menuItem: 'Kreiranje',
                render: () => (<Tab.Pane attached={false} responsive={Responsive}>
                    <DocumentTemplateConfiguration
                        manipulateConfig
                        changeStep={this.changeStep}
                        sharedSelection={sharedSelection}
                        onSelectionChange={this.handleSelectionChange}
                    />
                </Tab.Pane>),
            },
            ...(isAdmin ? [{
                menuItem: 'Katalog',
                render: () => (<Tab.Pane attached={false} responsive={Responsive}>
                    <TemplateCatalogOverview />
                </Tab.Pane>),
            }] : []),

        ];
        return (
            <div>
                <Header as="h1" content="Konfiguracije dokumenata" />
                <Grid columns="equal" centered className="stackable">
                    <Grid.Column>
                        <Segment.Group raised>
                            <Segment>
                                <Header as="h3">
                                    Konfiguracija
                                </Header>
                            </Segment>
                            <Segment>
                                <Tab id="myTab" menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} />
                            </Segment>
                            <ToastContainer hideProgressBar />
                        </Segment.Group>
                    </Grid.Column>
                </Grid>
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/DocumentTemplateConfiguration/TemplateConfig.js